export var SelectorRowType;
(function (SelectorRowType) {
    SelectorRowType["OPTION"] = "OPTION";
    SelectorRowType["LINK"] = "LINK";
    SelectorRowType["SELECTOR_SIMPLE"] = "SELECTOR_SIMPLE";
    SelectorRowType["SELECTOR_MULTIPLE"] = "SELECTOR_MULTIPLE";
})(SelectorRowType || (SelectorRowType = {}));
//# sourceMappingURL=selectorRow.js.map